'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Other(name) {
  this.Km = null;
  this.Km = name;
}
export { $c_Lpresto_crud$Other as $c_Lpresto_crud$Other };
$p = $c_Lpresto_crud$Other.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Other;
/** @constructor */
function $h_Lpresto_crud$Other() {
}
export { $h_Lpresto_crud$Other as $h_Lpresto_crud$Other };
$h_Lpresto_crud$Other.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_crud$Other) && (this.Km === x$0.Km)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "Other";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Km;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jd)));
}
export { $isArrayOf_Lpresto_crud$Other as $isArrayOf_Lpresto_crud$Other };
var $d_Lpresto_crud$Other = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Other, "presto.crud$Other", ({
  jd: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$Other as $d_Lpresto_crud$Other };
//# sourceMappingURL=presto.crud$-Other.js.map
